<div class="bsg-input-wrapper" id="searchbar" [ngClass]="isOpen ? 'mb-500' : 'mb-0'">
  <div class="input-group col-md-12 col-sm-12 col-lg-6">
    <div class="form-control-component">
      <ng2-completer class="searchbar-completer"
                     [placeholder]="('searchbar.placeholderText' | translate)"
                     [textSearching]="('searchbar.searchingText' | translate)"
                     [textNoResults]="('searchbar.noResults' | translate)"
                     [datasource]="dataService"
                     [minSearchLength]="2"
                     [pause]="debounceTime"
                     [inputClass]="'form-control form-control-inline'"
                     [fillHighlighted]="false"
                     [matchClass]="'match'"
                     (selected)="onSelected($event)"
                     (opened)="onOpen($event)">
      </ng2-completer>
    </div>
    <div class="input-group-append">
      <div class="input-group-text bg-white border-left-0"><i class="fa fa-search" style="color:grey"></i></div>
      <button tabindex="-1" class="btn btn-white" type="button" (click)="emptyCompleter()">
        <span class="fas fa-times"></span>
      </button>
    </div>
  </div>
</div>
